import tick from "assets/images/microsite/benefits/tick.svg";
import styled from "styled-components";
import parse from "html-react-parser";

const TickContainer = styled.div`
  position: relative;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  img {
    width: 16px;
    height: 16px;
    opacity: ${(props) => (props.isActive ? 1 : 0.3)};
    transition: opacity 0.3s ease;
  }
`;

const BenefitItem = ({ number, title, content, delay, isActive = true }) => (
  <div className="position-relative z-0 d-flex gap-6 pl-1.5 md:gap-8">
    <div className="position-relative text-xs">
      <TickContainer isActive={isActive}>
        <img src={tick} alt="" />
      </TickContainer>
    </div>
    <div data-aos="fade-left" data-aos-delay={delay}>
      <div className="mb-5 mx-5">
        <div className="text-section-row-title-v2 ">{title}</div>
        <div className="">{content}</div>
      </div>
    </div>
  </div>
);

export default BenefitItem;
